import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "main-container"
};
const _hoisted_2 = {
  class: "card-header"
};
const _hoisted_3 = {
  class: "filter-container"
};
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "action-list"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1,
  class: "action-bar"
};
const _hoisted_10 = {
  class: "dialog-footer"
};
import Pagination from '@/components/Pagination.vue';
import { useRouter, useRoute } from 'vue-router';
import { getCurrentInstance, reactive, onMounted, ref, nextTick } from 'vue';
import { beforeUpload, upload, fileUpload } from '@/utils/upload';
import { Plus } from '@element-plus/icons-vue';
import Keys from '@/constant/key';
import { joinParams } from '@/utils/index';
import { useStore } from '@/store/index';
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyQualification',
  setup(__props) {
    const CorrelationProps = {
      label: 'name',
      value: 'id'
    };
    const {
      proxy
    } = getCurrentInstance();
    const router = useRouter();
    const store = useStore();
    const route = useRoute();
    const userGroups = store.state.user.userInfo.group_id.split(',');
    const filters = reactive({
      grade: route.meta.grade ? route.meta.grade : '',
      classify_id: '',
      name: '',
      title: route.meta.title ? route.meta.title : '',
      page: 1,
      page_size: 10
    });
    const state = reactive({
      dialogVisible: false,
      catList: [],
      srcList: [],
      classify_name: '',
      img: '',
      url: '',
      grade: route.meta.grade,
      name: '',
      offIds: ''
    });
    const FilesList = ref([]);
    const tableData = ref([]);
    const total = ref(0);
    const cityList = ref([]);
    // 类型搜索
    const onCompanySearch = (queryString, cb) => {
      const results = queryString ? state.catList.filter(item => item.name.indexOf(queryString) > -1) : state.catList;
      cb(results);
    };
    const onFileChange = val => {
      var _FilesList$value$find;
      // @ts-ignore
      filters.name = ((_FilesList$value$find = FilesList.value.find(item => item.id === val)) === null || _FilesList$value$find === void 0 ? void 0 : _FilesList$value$find.name) || '';
    };
    //获取关键词关联信息
    const getCorrelationList = () => {
      proxy.$http.get('/dsapi/fileAssociation', filters).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        // 使用 map 方法将每个数组元素转换为一个对象
        FilesList.value = data.names.map((item, index) => {
          return {
            name: item,
            id: index
          };
        });
      });
    };
    // 选中监听
    const onSelectionChange = val => {
      state.offIds = val.map(item => item.id).join(',');
    };
    // 批量下载
    const batchDown = () => {
      let client_ip = localStorage.getItem('ip');
      if (state.offIds) {
        window.open(`${Keys.baseUrl}/dsapi/packDownload?${joinParams({
          ids: state.offIds,
          grade: route.meta.grade,
          user_name: store.state.user.userInfo.username,
          client_ip
        })}`);
      } else {
        proxy.$message({
          type: 'error',
          message: '请选择文件'
        });
      }
    };
    //获取类型
    const getCatList = () => {
      proxy.$http.get('/dsapi/classifyList', {
        grade: filters.grade
      }).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        state.catList = data;
      });
    };
    // 获取列表数据
    const getList = () => {
      proxy.$http.get('/dsapi/DataBankList', filters).then(res => {
        const {
          code,
          data,
          msg
        } = res;
        if (code != 200) {
          return proxy.$message({
            type: 'error',
            message: msg
          });
        }
        tableData.value = data.data;
        total.value = data.total;
      });
    };
    //打开弹窗
    const openDialog = row => {
      state.dialogVisible = true;
    };
    // 关闭弹框
    const dialogBeforeClose = () => {
      //清除数据
      state.classify_name = '', state.img = '', state.url = '', state.name = '', state.dialogVisible = false;
      nextTick(() => {
        proxy.$refs['addFile'].clearValidate();
      });
    };
    const onBeforeUpload = file => {
      return beforeUpload(file, {
        size: 1024 * 35
      });
    };
    //预览图上传
    const uploadImg = async param => {
      const res = await upload(param.file, {
        folderName: 'brands'
      });
      const {
        code,
        data,
        msg
      } = res;
      if (code != 200) {
        return proxy.$message({
          type: 'error',
          message: msg
        });
      }
      const {
        uid,
        img_info
      } = data;
      const {
        id,
        o_path: url,
        file_name
      } = img_info;
      let item = {
        id,
        url,
        file_name
      };
      state.img = url;
    };
    const getFileSuffix = name => {
      return name.slice((name.lastIndexOf(".") - 1 >>> 0) + 2);
    };
    const isValidImageType = name => {
      // 列出允许的图片文件后缀类型
      const validImageTypes = ['jpg', 'jpeg', 'png', 'gif'];
      // 获取文件后缀
      const suffix = getFileSuffix(name).toLowerCase();
      // 检查文件后缀是否在允许的类型列表中
      return validImageTypes.includes(suffix);
    };
    //上传文件
    const uploadFile = async param => {
      const {
        code,
        data,
        msg
      } = await fileUpload(param.file, {
        folderName: 'folder'
      });
      if (code != 200) {
        return proxy.$message({
          type: 'error',
          message: msg
        });
      }
      const {
        uid,
        file_name,
        url
      } = data;
      state.url = url;
      state.name = file_name;
    };
    //删除品牌图片
    const removeLogoImage = () => {
      state.img = '';
    };
    //删除文件
    const onRemove = () => {
      state.name = '';
      state.url = '';
    };
    const toDown = id => {
      let client_ip = localStorage.getItem('ip');
      window.open(`${Keys.baseUrl}/dsapi/download?${joinParams({
        id,
        user_name: store.state.user.userInfo.username,
        client_ip
      })}`);
    };
    //跳转到日志页
    const toLog = row => {
      const {
        grade,
        name,
        classify_id
      } = row;
      router.push(`/data-management/log?grade=${grade}&name=${name}&classify_id=${classify_id}`);
    };
    // 删除
    const onDel = id => {
      proxy.$confirm(`确定要删除该文件吗？`, '删除提示', {
        type: 'warning'
      }).then(() => {
        proxy.$http.post('/dsapi/dataBankDel', {
          id
        }).then(res => {
          const {
            code,
            msg
          } = res;
          if (code != 200) {
            return proxy.$message({
              type: 'error',
              message: msg
            });
          }
          proxy.$message({
            type: 'success',
            message: '删除成功'
          });
          getList();
        });
      }).catch(() => {
        console.log('取消删除');
      });
    };
    //新增编辑品牌
    const updateRow = row => {
      proxy.$refs['addFile'].validate(valid => {
        if (valid) {
          // if(!state.img){
          //     return proxy.$message({ type: 'error', message: '请上传预览图' })
          // }
          proxy.$http.post('/dsapi/addDataBank', state).then(res => {
            const {
              code,
              data,
              msg
            } = res;
            if (code != 200) {
              return proxy.$message({
                type: 'error',
                message: msg
              });
            }
            proxy.$message({
              type: 'success',
              message: '保存成功'
            });
            dialogBeforeClose();
            getList();
            getCatList();
          });
        }
      });
    };
    const brandRules = reactive({
      classify_name: [{
        required: true,
        message: '请输入类型',
        trigger: 'blur'
      }]
    });
    const search = () => {
      filters.page = 1;
      getList();
    };
    const onPageChange = val => {
      filters.page = val;
      getList();
    };
    const onSizeChange = val => {
      filters.page_size = val;
      getList();
    };
    // 观察路由的 meta 信息变化
    watch(() => route.meta, (newMeta, oldMeta) => {
      const {
        grade,
        title
      } = newMeta;
      // 当路由的 meta 信息变化时执行需要的操作
      if (grade && title) {
        filters.grade = newMeta.grade;
        filters.title = newMeta.title;
        state.grade = newMeta.grade;
      }
      filters.classify_id = '';
      filters.name = '';
      getList();
      getCatList();
      getCorrelationList();
    }, {
      deep: true // 开启深度监听，以便能够检测 meta 对象内部属性的变化
    });
    onMounted(() => {
      getList();
      getCatList();
      getCorrelationList();
    });
    return (_ctx, _cache) => {
      const _component_el_select_v2 = _resolveComponent("el-select-v2");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_autocomplete = _resolveComponent("el-autocomplete");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_upload = _resolveComponent("el-upload");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", null, "销售部-" + _toDisplayString(filters.title), 1)]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_select_v2, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => filters.name = $event),
        ref: "brandRef",
        filterable: "",
        options: FilesList.value,
        props: CorrelationProps,
        placeholder: "文件名称",
        onChange: _cache[1] || (_cache[1] = $event => onFileChange(filters.name)),
        clearable: ""
      }, null, 8, ["modelValue", "options"]), _createVNode(_component_el_select, {
        class: "filter-item",
        modelValue: filters.classify_id,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => filters.classify_id = $event),
        placeholder: "类型",
        filterable: "",
        clearable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.catList, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.name,
            value: item.id
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = $event => search())
      }, {
        default: _withCtx(() => _cache[11] || (_cache[11] = [_createTextVNode("搜索")])),
        _: 1
      }), _unref(userGroups).includes('55') || _unref(userGroups).includes('1') ? (_openBlock(), _createBlock(_component_el_button, {
        key: 0,
        class: "filter-btn",
        type: "primary",
        onClick: openDialog
      }, {
        default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("新增")])),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: batchDown
      }, {
        default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("批量下载")])),
        _: 1
      })]), _createVNode(_component_el_table, {
        ref: "multipleTableRef",
        data: tableData.value,
        stripe: "",
        border: "",
        onSelectionChange: onSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "selection"
        }), _createVNode(_component_el_table_column, {
          type: "index"
        }), _createVNode(_component_el_table_column, {
          prop: "classify_name",
          label: "类型"
        }), _createVNode(_component_el_table_column, {
          prop: "name",
          label: "文件名称"
        }), _createVNode(_component_el_table_column, {
          prop: "add_time",
          label: "上传时间",
          width: "390"
        }), _createVNode(_component_el_table_column, {
          prop: "user_name",
          label: "上传人"
        }), _createVNode(_component_el_table_column, {
          prop: "url",
          label: "预览"
        }, {
          default: _withCtx(scope => [scope.row.img ? (_openBlock(), _createBlock(_component_el_image, {
            key: 0,
            style: {
              "width": "50px",
              "height": "40px"
            },
            src: scope.row.img,
            "zoom-rate": 1.2,
            "preview-src-list": state.srcList,
            fit: "cover",
            onClick: $event => state.srcList = [scope.row.img],
            "z-index": 1000,
            "preview-teleported": true
          }, null, 8, ["src", "preview-src-list", "onClick"])) : (_openBlock(), _createElementBlock("span", _hoisted_4))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作",
          width: "200"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => toDown(scope.row.id)
          }, {
            default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" 下载 ")])),
            _: 2
          }, 1032, ["onClick"]), _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: $event => toLog(scope.row)
          }, {
            default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode(" 日志 ")])),
            _: 2
          }, 1032, ["onClick"]), _unref(userGroups).includes('55') || _unref(userGroups).includes('1') ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            size: "small",
            onClick: $event => onDel(scope.row.id)
          }, {
            default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode(" 删除 ")])),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data"]), _createVNode(Pagination, {
        currentPage: filters.page,
        total: total.value,
        onPageChange: onPageChange,
        onSizeChange: onSizeChange
      }, null, 8, ["currentPage", "total"]), _createVNode(_component_el_dialog, {
        title: "新增文件",
        style: {
          "width": "1000px"
        },
        modelValue: state.dialogVisible,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => state.dialogVisible = $event),
        "before-close": dialogBeforeClose
      }, {
        footer: _withCtx(scope => [_createElementVNode("span", _hoisted_10, [_createVNode(_component_el_button, {
          type: "primary",
          size: "small",
          onClick: _cache[9] || (_cache[9] = $event => updateRow(state))
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("保存")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_form, {
          model: state,
          "label-width": "90",
          ref: "addFile",
          rules: brandRules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "新建类型",
            prop: "classify_name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_autocomplete, {
              modelValue: state.classify_name,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => state.classify_name = $event),
              "fetch-suggestions": onCompanySearch,
              "value-key": "name",
              clearable: "",
              placeholder: "请输入类型"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "上传文件",
            required: ""
          }, {
            default: _withCtx(() => [!isValidImageType(state.name) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [state.name ? (_openBlock(), _createBlock(_component_el_link, {
              key: 0,
              href: state.url,
              target: "_blank"
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(state.name), 1)]),
              _: 1
            }, 8, ["href"])) : _createCommentVNode("", true), state.url ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "color-primary",
              onClick: _cache[5] || (_cache[5] = $event => onRemove())
            }, "删除")) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_image, {
              class: "content-img",
              src: state.url,
              fit: "scale-down",
              "hide-on-click-modal": "",
              "append-to-body": "",
              "z-index": 3000,
              style: {
                "width": "150px"
              }
            }, null, 8, ["src"]), state.url ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "color-primary",
              onClick: _cache[6] || (_cache[6] = $event => onRemove())
            }, "删除")) : _createCommentVNode("", true)])), !state.url ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 2,
              ref: "imageUpload",
              class: "el-upload-list__item empty-item",
              action: "uploadUrl",
              "before-upload": onBeforeUpload,
              "http-request": uploadFile,
              "show-file-list": false,
              "list-type": "picture-card",
              style: {
                "width": "auto"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            }, 512)) : _createCommentVNode("", true), _cache[17] || (_cache[17] = _createElementVNode("span", {
              class: "tips"
            }, "支持ppt、doc, docx, rtf, xml, txt, pdf，jpg", -1))]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            class: "content-img-form-item",
            label: "添加预览图",
            style: {
              "width": "380px"
            }
          }, {
            default: _withCtx(() => [state.img ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_image, {
              class: "content-img",
              src: state.img,
              fit: "scale-down",
              "hide-on-click-modal": "",
              onClick: _cache[7] || (_cache[7] = $event => state.srcList = [state.img]),
              "preview-src-list": state.srcList,
              "append-to-body": "",
              "z-index": 3000,
              style: {
                "width": "150px"
              }
            }, null, 8, ["src", "preview-src-list"])])) : _createCommentVNode("", true), state.img ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("span", {
              class: "color-primary",
              style: {
                "cursor": "pointer"
              },
              onClick: _cache[8] || (_cache[8] = $event => removeLogoImage())
            }, "删除")])) : _createCommentVNode("", true), !state.img ? (_openBlock(), _createBlock(_component_el_upload, {
              key: 2,
              ref: "imageUpload",
              class: "el-upload-list__item empty-item",
              accept: ".jpg,.jpeg,.png",
              action: "uploadUrl",
              "http-request": uploadImg,
              "show-file-list": false,
              "list-type": "picture-card",
              style: {
                "width": "auto"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_unref(Plus))]),
                _: 1
              })]),
              _: 1
            }, 512)) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }, 8, ["model", "rules"])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});